import React, { Component } from 'react';
import {
    MDBContainer,
    MDBJumbotron,
    Row,
    Col,
    // Card, 
    // CardBody, 
    // Fa, 
    //Button, 
    // Input
} from 'mdbreact';

const headerStyle = {
    fontFamily: "Arial, Helvetica, sans-serif",
    color: "#000000",
  };

class PrivacyPage extends Component {
    render() {
        return (
            <MDBContainer>
                <MDBJumbotron style={{ marginTop: "1rem" }}>
                    

  

  <div id="cascade-privacy-policy">
      <h1 style={headerStyle}>Privacy Policy</h1>

      <p>
        <strong>Effective Date:</strong> March 9, 2026
      </p>

      <p>
        Cascade Holdings, LLC ("Company," "we," "our," or "us") respects your
        privacy and is committed to protecting the personal information you
        provide when using our application, website, and related services. This
        Privacy Policy applies to the <strong>Cascade Exteriors</strong>{" "}
        application (the "App") and explains how we collect, use, disclose, and
        safeguard your information.
      </p>

      <p>
        By accessing or using the App, you agree to the collection and use of
        information in accordance with this Privacy Policy.
      </p>

      <h2 style={headerStyle}>1. Information We Collect</h2>

      <p>We may collect information about you in several ways, including the following:</p>

      <h3 style={headerStyle}>Personal Information</h3>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Property address or job location</li>
        <li>Company name (if applicable)</li>
        <li>Account login credentials</li>
      </ul>

      <h3 style={headerStyle}>Project and Service Information</h3>
      <p>To provide our exterior subcontracting and related services, we may collect:</p>
      <ul>
        <li>Service requests</li>
        <li>Project descriptions and notes</li>
        <li>Photos, videos, documents, or files uploaded through the App</li>
        <li>Work orders, estimates, and project updates</li>
        <li>Communications related to services or support</li>
      </ul>

      <h3 style={headerStyle}>Device and Technical Information</h3>
      <p>When you use the App, certain information may be collected automatically, including:</p>
      <ul>
        <li>Device type</li>
        <li>Operating system</li>
        <li>IP address</li>
        <li>Browser type</li>
        <li>App usage activity</li>
        <li>Diagnostic, crash, and performance data</li>
      </ul>

      <h3 style={headerStyle}>Location Information</h3>
      <p>
        With your permission, the App may collect location information from your
        device. Location data may be used to support project coordination, job
        site documentation, and operational features within the App.
      </p>

      <h3 style={headerStyle}>Camera and Media Access</h3>
      <p>
        The App may request access to your device camera or photo library to
        allow you to capture and upload photos or other media related to
        projects, job documentation, inspections, or service requests.
      </p>

      <h3 style={headerStyle}>Account Authentication</h3>
      <p>
        Users may be required to create an account and log in to access certain
        features of the App. Login credentials are used to authenticate users
        and maintain secure access to project and operational data.
      </p>

      <h2 style={headerStyle}>2. How We Use Your Information</h2>

      <p>We use the information we collect to:</p>

      <ul>
        <li>Provide, operate, and maintain the Cascade Exteriors App</li>
        <li>Schedule, coordinate, and manage subcontracting services</li>
        <li>Communicate with customers, contractors, and partners</li>
        <li>Send operational updates and service notifications</li>
        <li>Enable push notifications related to project updates or system alerts</li>
        <li>Improve functionality, reliability, and user experience</li>
        <li>Maintain system security and prevent unauthorized use</li>
        <li>Comply with legal and regulatory requirements</li>
      </ul>

      <h3 style={headerStyle}>Push Notifications</h3>
      <p>
        The App may send push notifications to provide project updates,
        operational alerts, or service-related communications. You may disable
        push notifications in your device settings at any time.
      </p>

      <p>We do not sell personal information.</p>

      <h2 style={headerStyle}>3. How We Share Information</h2>

      <h3 style={headerStyle}>Service Providers</h3>
      <p>
        We may share information with trusted service providers who support the
        operation of the App.
      </p>

      <p>
        The Cascade Exteriors App is provided through a white-labeled platform
        operated by <strong>TrackVia, Inc.</strong> Information submitted
        through the App may be processed or stored by TrackVia, Inc. and its
        infrastructure providers as necessary to operate and maintain the
        platform.
      </p>

      <h3 style={headerStyle}>Contractors and Business Partners</h3>
      <p>
        Project-related information may be shared with employees,
        subcontractors, suppliers, and project managers when necessary to
        coordinate work or fulfill services.
      </p>

      <h3 style={headerStyle}>Legal Requirements</h3>
      <p>We may disclose information if necessary to:</p>
      <ul>
        <li>Comply with applicable law or legal process</li>
        <li>Protect our rights, operations, or property</li>
        <li>Protect the safety of users, customers, or the public</li>
      </ul>

      <h2 style={headerStyle}>4. Data Security</h2>
      <p>
        We use reasonable administrative, technical, and physical safeguards to
        protect personal information from unauthorized access, disclosure,
        alteration, or destruction. However, no internet-based system can
        guarantee absolute security.
      </p>

      <h2 style={headerStyle}>5. Data Retention</h2>
      <p>
        We retain personal information only as long as reasonably necessary to
        provide services, maintain business records, resolve disputes, and
        comply with legal obligations.
      </p>

      <h2 style={headerStyle}>6. Your Privacy Rights</h2>
      <p>Subject to applicable law, you may have the right to:</p>
      <ul>
        <li>Request access to personal information we maintain about you</li>
        <li>Request correction of inaccurate information</li>
        <li>Request deletion of certain personal data</li>
      </ul>

      <p>Requests may be submitted using the contact information listed below.</p>

      <h2 style={headerStyle}>7. Children's Privacy</h2>
      <p>
        The App is not intended for children under the age of 13. We do not
        knowingly collect personal information from children under 13.
      </p>

      <h2 style={headerStyle}>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy periodically. Updates will be posted
        on this page with a revised effective date.
      </p>

      <h2 style={headerStyle}>9. Contact Information</h2>
      <p>
        <strong>Cascade Holdings, LLC</strong>
        <br />
        Email: <a href="mailto:it@cascade.build">it@cascade.build</a>
      </p>
    </div>


                </MDBJumbotron>
                
            </MDBContainer>
        );
    };
}

export default PrivacyPage;